import { useState } from "react";
import CloudinaryService from "../services/CloudinaryService";


function useCloudinary() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);


  const uploadWeeklyShipImage = async (FormData) => {
    try {
      const response = await CloudinaryService.uploadWeeklyShipImage(FormData);
      return response.data.message
    } catch (err) {
      setError(err.response.data.message);
      console.log(err.response.data.message)
      setIsLoading(false);
      return false
    }
  }

  const uploadReceiptImage = async (FormData) => {
    try {
      const response = await CloudinaryService.uploadReceiptImage(FormData);
      setIsLoading(true)
      return response.data.message
    } catch (err) {
      setError(err.response.data.message);
      console.log(err)
      setIsLoading(false);
      return false
    }
  }

  const uploadAirShipImage = async (FormData) => {
    try {
      const response = await CloudinaryService.uploadAirShipImage(FormData);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Upload failed');
      setIsLoading(false);
      return false;
    }
  }

  return { 
    error,
    isLoading,
    uploadWeeklyShipImage,
    uploadReceiptImage,
    uploadAirShipImage
  };
}

export default useCloudinary;